import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

export const getPasswordRules = (password) => ({
  length: password.length >= 12 && password.length <= 128,
  number: /\d/.test(password),
  uppercase: /[A-Z]/.test(password),
  lowercase: /[a-z]/.test(password),
  special: /[!@#$%^&*()_=+[\]{};:,.?-]/.test(password)
});

export const isPasswordValid = (password) => {
  const rules = getPasswordRules(password);
  return Object.values(rules).every(Boolean);
};

const PasswordRule = ({ valid, text, isFocused }) => {
  let color = '#888';
  let Icon = RadioButtonUncheckedIcon;

  if (isFocused) {
    if (valid) {
      color = 'green';
      Icon = CheckCircleIcon;
    } else {
      color = 'red';
      Icon = CancelIcon;
    }
  }

  return (
    <div style={{ color, marginTop: '4px', display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Icon style={{ fontSize: '14px' }} />
      <Typography variant="body2" sx={{ fontSize: '12px' }}>{text}</Typography>
    </div>
  );
};

PasswordRule.propTypes = {
  valid: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  isFocused: PropTypes.bool
};

PasswordRule.defaultProps = {
  isFocused: false
};

const PasswordRules = ({ password, isFocused }) => {
  const rules = getPasswordRules(password);

  return (
    <div style={{ marginTop: '8px' }}>
      <PasswordRule valid={rules.length} text="At least 12 characters" isFocused={isFocused} />
      <PasswordRule valid={rules.number} text="Contains a number" isFocused={isFocused} />
      <PasswordRule valid={rules.uppercase} text="Contains uppercase letter" isFocused={isFocused} />
      <PasswordRule valid={rules.lowercase} text="Contains lowercase letter" isFocused={isFocused} />
      <PasswordRule valid={rules.special} text="Contains special character" isFocused={isFocused} />
    </div>
  );
};

PasswordRules.propTypes = {
  password: PropTypes.string.isRequired,
  isFocused: PropTypes.bool
};

PasswordRules.defaultProps = {
  isFocused: false
};

export default PasswordRules;
